import { Component, computed, input, ChangeDetectionStrategy, inject, OnInit, signal } from '@angular/core'
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { ButtonComponent } from '../button/button.component'
import { RouterLink } from '@angular/router'
import { LocalStorageService } from '../../../core/services/local-storage.service'

@Component({
    selector: 'sq-trial-banner',
    standalone: true,
    imports: [RouterLink, NgbAlertModule, FontAwesomeModule, ButtonComponent],
    template: `
        <ngb-alert [hidden]="!showBanner()" type="warning" [dismissible]="true" (closed)="closed()">
            <div class="d-flex align-items-center justify-content-center gap-2">
                <fa-icon [icon]="['fas', 'clock']"></fa-icon>
                <span>
                    <strong>Trial Period:</strong>
                    @if (daysRemaining() > 0) {
                        You have
                        <strong>{{ daysRemaining() }} day{{ daysRemaining() === 1 ? '' : 's' }}</strong> left on your
                        trial.
                    } @else if (daysRemaining() === 0) {
                        Your trial ends <strong>today</strong>!
                    } @else {
                        Your trial has <strong>expired</strong>.
                    }
                    Upgrade now to continue enjoying all features.
                </span>
                <a sqButton color="warning" size="sm" class="ms-2" [routerLink]="['/subscription']">Upgrade Now</a>
            </div>
        </ngb-alert>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: ``,
})
export class TrialBannerComponent implements OnInit {
    #localStorage = inject(LocalStorageService)

    showBanner = signal(true)
    trialEndDate = input.required<string | null>()

    daysRemaining = computed(() => {
        const endDate = this.trialEndDate()
        if (!endDate) return 0

        const end = new Date(endDate)
        const now = new Date()
        const diffTime = end.getTime() - now.getTime()
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        return diffDays
    })

    ngOnInit() {
        const closed = this.#localStorage.get('trialBannerClosed')
        if (closed) {
            this.showBanner.set(false)
        }
    }

    closed() {
        this.showBanner.set(false)
        this.#localStorage.set('trialBannerClosed', true)
    }
}
